/**
 * TemplateCompatibilityTab — the model and tool requirements of a template. Demo page: /ui-elements/cards.
 */
import React from 'react';
import { Card } from '../../../components/ui/index.js';
import type { AgentTemplate } from '../../../generated/api/types.gen.js';
import { sentenceCase } from '../../../components/ui/FilterSelect.js';
import { FactList, FactRow, TokenList } from './detail-parts.js';

const NOT_SPECIFIED = 'Not specified';

export const TemplateCompatibilityTab: React.FC<{ template: AgentTemplate }> = ({ template }) => {
  const compatibility = template.compatibility;
  return (
    <div className="grid items-start gap-5 xl:grid-cols-2">
      <Card title="Requirements">
        <FactList>
          <FactRow label="Latency" value={compatibility?.latencyClass ?? NOT_SPECIFIED} />
          <FactRow
            label="Context window"
            value={
              compatibility?.minContextWindow
                ? `${compatibility.minContextWindow.toLocaleString()} tokens`
                : NOT_SPECIFIED
            }
          />
          <FactRow label="Cost target" value={compatibility?.preferredCost ?? NOT_SPECIFIED} />
          <FactRow
            label="Permission tier"
            value={sentenceCase(compatibility?.permissionTier ?? template.permissionTier ?? 'observer')}
          />
        </FactList>
      </Card>
      <Card title="Capabilities">
        <div className="space-y-5">
          <TokenList
            label="Model capabilities"
            values={compatibility?.modelCapabilities ?? []}
            empty="No model capability requirements declared."
          />
          <TokenList
            label="Tools"
            values={(compatibility?.tools ?? []).map((tool) => (tool.required ? `${tool.name} (required)` : tool.name))}
            empty="No tools required."
          />
          <TokenList
            label="MCP connections"
            values={compatibility?.mcpConnections ?? []}
            empty="No MCP connections used."
          />
        </div>
      </Card>
    </div>
  );
};
